<template>
  <div>
    <Menu />
    <section id="banner" class="my-5">
      <div class="container">
        <div class="row justify-content-center g-0">
          <div class="col-12">
            <div class="banner-section">
              <img src="/images/banners/lifestyle-banner.png" class="w-100" />
            </div>
          </div>
        </div>
      </div>
    </section>

    <section>
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-lg-7 text-center mb-5">
            <h1>LIFESTYLE</h1>
            <p>
              Immerse yourself in the art of indulgence, where luxury living takes centre stage.<br>
              Discover secluded holiday destinations, exquisite wines, the finest restaurants, private events, flawless interior decorating,
              inspiring landscaping designs and more. Embrace the extraordinary and delve into a lavish lifestyle.
            </p>
          </div>

          <div class="col-12">
            <div class="row">
              <div class="col-lg-3 col-md-4 mb-4">
                <div class="d-flex flex-column align-items-md-start align-items-center gap-2 sticky-top" style="top: 140px;">
                  <button class="btn btn-primary filter-btn" :class="{ 'active': selectedCategory === 'all' }" v-on:click="selectedCategory = 'all'">ALL</button>
                  <button class="btn btn-primary filter-btn" :class="{ 'active': selectedCategory === 'the-art-of-living' }" v-on:click="selectedCategory = 'the-art-of-living'">THE ART OF LIVING</button>
                  <button class="btn btn-primary filter-btn" :class="{ 'active': selectedCategory === 'signature-estates' }" v-on:click="selectedCategory = 'signature-estates'">SIGNATURE ESTATES</button>
                  <button class="btn btn-primary filter-btn" :class="{ 'active': selectedCategory === 'inspired-interiors' }" v-on:click="selectedCategory = 'inspired-interiors'">INSPIRED INTERIORS</button>
                  <button class="btn btn-primary filter-btn" :class="{ 'active': selectedCategory === 'exclusive-destinations' }" v-on:click="selectedCategory = 'exclusive-destinations'">EXCLUSIVE DESTINATIONS</button>
                  <button class="btn btn-primary filter-btn" :class="{ 'active': selectedCategory === 'fine-pursuits' }" v-on:click="selectedCategory = 'fine-pursuits'">FINE PURSUITS</button>
                  <button class="btn btn-primary filter-btn" :class="{ 'active': selectedCategory === 'legacy-investments' }" v-on:click="selectedCategory = 'legacy-investments'">LEGACY INVESTMENTS</button>
                </div>
              </div>

              <div class="col-lg-9 col-md-8">
                <h2 class="visually-hidden">Luxury Lifestyle Articles</h2>
                <div class="row">


                  <!-- NEW ARTICLE: DUBAI -->
                  <div class="col-6 pb-5 d-flex" v-if="selectedCategory === 'all' || selectedCategory === 'legacy-investments'">
                    <div class="d-flex flex-column w-100">
                      <div class="p-3 bg-light rounded h-100 d-flex flex-column">
                        <a href="/article/luxnewdubai" class="d-block" style="text-decoration: none;">
                          <img
                            src="/images/lifestyle/luxnewdubai.jpg"
                            class="w-100 mb-3 lifestyle-img"
                            style="border-bottom-right-radius: 30px;"
                            alt="luxnewdubai"
                          />
                        </a>

                        <a href="/article/luxnewdubai" class="d-block" style="text-decoration: none;">
                          <h3 class="h4 text-start text-uppercase"><strong>Dubai office opens as Chas Everitt builds global property bridges</strong></h3>
                        </a>

                        <p class="blog-text">
                          Chas Everitt International has created a new gateway between South Africa and one of the world’s most dynamic property and financial markets with the opening of its first office in Dubai.
                        </p>
                      </div>
                    </div>
                  </div>


                  <!-- NEW ARTICLE: CURRENCIES DIRECT -->
                  <div class="col-6 pb-5 d-flex" v-if="selectedCategory === 'all' || selectedCategory === 'legacy-investments'">
                    <div class="d-flex flex-column w-100">
                      <div class="p-3 bg-light rounded h-100 d-flex flex-column">
                        <a href="/article/luxcurrencies" class="d-block" style="text-decoration: none;">
                          <img
                            src="/images/lifestyle/luxcurrencies.jpg"
                            class="w-100 mb-3 lifestyle-img"
                            style="border-bottom-right-radius: 30px;"
                            alt="luxcurrencies"
                          />
                        </a>

                        <a href="/article/luxcurrencies" class="d-block" style="text-decoration: none;">
                          <h3 class="h4 text-start text-uppercase"><strong>Unlocking seamless cross-border property acquisitions</strong></h3>
                        </a>

                        <p class="blog-text">
                          For affluent investors, purchasing prime real estate is rarely just about finding the perfect property. In the international market especially, navigating currency volatility, exchange control restrictions, and varying tax architectures is where the true success of an acquisition is decided, which is why we believe that our clients need expert help whenever they buy property outside of their own countries.
                        </p>
                      </div>
                    </div>
                  </div>


                  <!-- NEW ARTICLE: WHITE WINE -->
                  <div class="col-6 pb-5 d-flex" v-if="selectedCategory === 'all' || selectedCategory === 'fine-pursuits'">
                    <div class="d-flex flex-column w-100">
                      <div class="p-3 bg-light rounded h-100 d-flex flex-column">
                        <a href="/article/luxwhitewine" class="d-block" style="text-decoration: none;">
                          <img
                            src="/images/lifestyle/luxwhitewine.jpg"
                            class="w-100 mb-3 lifestyle-img"
                            style="border-bottom-right-radius: 30px;"
                            alt="luxwhitewine"
                          />
                        </a>

                        <a href="/article/luxwhitewine" class="d-block" style="text-decoration: none;">
                          <h3 class="h4 text-start text-uppercase"><strong>Cooler, crisper and increasingly world-class</strong></h3>
                        </a>

                        <p class="blog-text">
                          Summer is unfolding across the country, bringing with it the promise of languorous evenings enjoying one of life’s simplest pleasures: a perfectly chilled white wine.
                        </p>
                      </div>
                    </div>
                  </div>


                  <!-- NEW ARTICLE: DAINFERN -->
                  <div class="col-6 pb-5 d-flex" v-if="selectedCategory === 'all' || selectedCategory === 'signature-estates'">
                    <div class="d-flex flex-column w-100">
                      <div class="p-3 bg-light rounded h-100 d-flex flex-column">
                        <a href="/article/luxdainfern" class="d-block" style="text-decoration: none;">
                          <img
                            src="/images/lifestyle/luxdainfern.jpg"
                            class="w-100 mb-3 lifestyle-img"
                            style="border-bottom-right-radius: 30px;"
                            alt="luxdainfern"
                          />
                        </a>

                        <a href="/article/luxdainfern" class="d-block" style="text-decoration: none;">
                          <h3 class="h4 text-start text-uppercase"><strong>35 years on, Dainfern is still the gold standard of estate living</strong></h3>
                        </a>

                        <p class="blog-text">
                          Some residential developments come and go with changing property trends, while others become part of the history of a city.
                        </p>
                      </div>
                    </div>
                  </div>


                  <!-- NEW ARTICLE: DINER EN BLANC -->
                  <div class="col-6 pb-5 d-flex" v-if="selectedCategory === 'all' || selectedCategory === 'fine-pursuits'">
                    <div class="d-flex flex-column w-100">
                      <div class="p-3 bg-light rounded h-100 d-flex flex-column">
                        <a href="/article/luxdinerlead" class="d-block" style="text-decoration: none;">
                          <img
                            src="/images/lifestyle/luxdinerlead.jpg"
                            class="w-100 mb-3 lifestyle-img"
                            style="border-bottom-right-radius: 30px;"
                            alt="luxdinerlead"
                          />
                        </a>

                        <a href="/article/luxdinerlead" class="d-block" style="text-decoration: none;">
                          <h3 class="h4 text-start text-uppercase"><strong>All in white, with a bit of bling…</strong></h3>
                        </a>

                        <p class="blog-text">
                          There are few things as utterly glamorous as a sea of elegantly dressed guests gathering under the stars for an evening of dining, dancing and celebration, and Dainfern Golf Estate provided the perfect setting when its community came together recently for a spectacular Dîner en Blanc.
                        </p>
                      </div>
                    </div>
                  </div>


                  <!-- NEW ARTICLE: LAB-GROWN DIAMONDS -->
                  <div class="col-6 pb-5 d-flex" v-if="selectedCategory === 'all' || selectedCategory === 'fine-pursuits'">
                    <div class="d-flex flex-column w-100">
                      <div class="p-3 bg-light rounded h-100 d-flex flex-column">
                        <a href="/article/luxdiamonds" class="d-block" style="text-decoration: none;">
                          <img
                            src="/images/lifestyle/luxdiamonds.jpg"
                            class="w-100 mb-3 lifestyle-img"
                            style="border-bottom-right-radius: 30px;"
                            alt="luxdiamonds"
                          />
                        </a>

                        <a href="/article/luxdiamonds" class="d-block" style="text-decoration: none;">
                          <h3 class="h4 text-start text-uppercase"><strong>Why the world is falling for the brilliance of lab-grown diamonds</strong></h3>
                        </a>

                        <p class="blog-text">
                          After 35 years in the diamond industry, gemmologist Max Barker and high jewellery designer Yossi Illos have seen thousands of beautiful stones of every shape, cut and colour, but what really gets them excited now is the future of laboratory-grown diamonds.
                        </p>
                      </div>
                    </div>
                  </div>


                  <!-- NEW ARTICLE: KLASERIE -->
                  <div class="col-6 pb-5 d-flex" v-if="selectedCategory === 'all' || selectedCategory === 'legacy-investments'">
                    <div class="d-flex flex-column w-100">
                      <div class="p-3 bg-light rounded h-100 d-flex flex-column">
                        <a href="/article/luxklaserie" class="d-block" style="text-decoration: none;">
                          <img
                            src="/images/lifestyle/luxklaserie.jpg"
                            class="w-100 mb-3 lifestyle-img"
                            style="border-bottom-right-radius: 30px;"
                            alt="luxklaserie"
                          />
                        </a>

                        <a href="/article/luxklaserie" class="d-block" style="text-decoration: none;">
                          <h3 class="h4 text-start text-uppercase"><strong>Rare by nature: Why Klaserie properties are so valuable</strong></h3>
                        </a>

                        <p class="blog-text">
                          For most people, buying property is about location, lifestyle and investment potential. But ownership in the Klaserie Private Nature Reserve offers something much more satisfying: The opportunity to become part of one of Africa’s great conservation landscapes.
                        </p>
                      </div>
                    </div>
                  </div>

                <div class="col-6 pb-5 d-flex" v-if="selectedCategory === 'all' || selectedCategory === 'legacy-investments'">
                    <div class="d-flex flex-column w-100">
                      <div class="p-3 bg-light rounded h-100 d-flex flex-column">
                        <a href="/article/luxwaterkloof" class="d-block" style="text-decoration: none;">
                          <img
                            src="/images/lifestyle/luxwaterkloof.jpg"
                            class="w-100 mb-3 lifestyle-img"
                            style="border-bottom-right-radius: 30px;"
                            alt="luxwaterkloof"
                          />
                        </a>

                        <a href="/article/luxwaterkloof" class="d-block" style="text-decoration: none;">
                         <h3 class="h4 text-start text-uppercase"><strong>The Pretoria suburb where diplomacy and luxury living converge </strong></h3>
                        </a>

                        <p class="blog-text">
                        The recent record sale of a home in Waterkloof for R30m has put the spotlight back on a suburb that is one of Pretoria's real estate jewels. The property, a beautifully renovated six-bedroom, six-bathroom residence on a 2500sqm stand in sought-after Edward Street, was sold by two of Chas Everitt’s dedicated area specialists and reflects the strong demand for premium homes in one of South Africa's most established luxury residential enclaves.
                        </p>
                      </div>

                    </div>
                  </div>


                  <div class="col-6 pb-5 d-flex" v-if="selectedCategory === 'all' || selectedCategory === 'legacy-investments'">
                    <div class="d-flex flex-column w-100">
                      <div class="p-3 bg-light rounded h-100 d-flex flex-column">
                        <a href="/article/luxcapetown" class="d-block" style="text-decoration: none;">
                          <img
                            src="/images/lifestyle/luxcapetown.jpg"
                            class="w-100 mb-3 lifestyle-img"
                            style="border-bottom-right-radius: 30px;"
                            alt="luxcapetown"
                          />
                        </a>

                        <a href="/article/luxcapetown" class="d-block" style="text-decoration: none;">
                         <h3 class="h4 text-start text-uppercase"><strong>Living large in the vibrant heart of Cape Town </strong></h3>
                        </a>

                        <p class="blog-text">
                        For diplomats, international executives and foreign investors exploring South Africa, Cape Town’s central city area offers an enticing combination of cosmopolitan energy, natural beauty and strong property fundamentals that very few global destinations can rival.
                        </p>
                      </div>

                    </div>
                  </div>

                  <div class="col-6 pb-5 d-flex" v-if="selectedCategory === 'all' || selectedCategory === 'legacy-investments'">
                    <div class="d-flex flex-column w-100">
                      <div class="p-3 bg-light rounded h-100 d-flex flex-column">
                        <a href="/article/luxconstantia" class="d-block" style="text-decoration: none;">
                          <img
                            src="/images/lifestyle/luxconstantia.jpg"
                            class="w-100 mb-3 lifestyle-img"
                            style="border-bottom-right-radius: 30px;"
                            alt="luxconstantia"
                          />
                        </a>

                        <a href="/article/luxconstantia" class="d-block" style="text-decoration: none;">
                         <h3 class="h4 text-start text-uppercase"><strong>
                         The quiet affluence of Cape Town’s most gracious suburbs
                          </strong></h3>
                        </a>

                        <p class="blog-text">
                        In an age of flashy penthouses and ultra-modern beachfront villas, Cape Town’s most enduring luxury addresses remain quietly understated. Tucked beneath the eastern slopes of Table Mountain, the leafy suburbs of Bishopscourt, Constantia and Newlands have long represented a different kind of prestige; one rooted not in spectacle, but in heritage, privacy and permanence
                        </p>
                      </div>

                    </div>
                  </div>


                  <div class="col-6 pb-5 d-flex" v-if="selectedCategory === 'all' || selectedCategory === 'legacy-investments'">
                    <div class="d-flex flex-column w-100">
                      <div class="p-3 bg-light rounded h-100 d-flex flex-column">
                        <a href="/article/luxcoast" class="d-block" style="text-decoration: none;">
                          <img
                            src="/images/lifestyle/luxnorthcoast.jpg"
                            class="w-100 mb-3 lifestyle-img"
                            style="border-bottom-right-radius: 30px;"
                            alt="luxncoast"
                          />
                        </a>

                        <a href="/article/luxcoast" class="d-block" style="text-decoration: none;">
                         <h3 class="h4 text-start text-uppercase"><strong>
                         Investors take note as Dolphin Coast booms
                          </strong></h3>
                        </a>

                        <p class="blog-text">
                        All eyes are on the KwaZulu-Natal North Coast at the moment with the opening of South Africa’s first Club Med resort, but this region offers even more than the promise of carefree days on dreamy sub-tropical beaches beside the warm Indian Ocean.
                        </p>
                      </div>

                    </div>
                  </div>


                  <div class="col-6 pb-5 d-flex" v-if="selectedCategory === 'all' || selectedCategory === 'legacy-investments'">
                    <div class="d-flex flex-column w-100">
                      <div class="p-3 bg-light rounded h-100 d-flex flex-column">
                        <a href="/article/luxvdvaward" class="d-block" style="text-decoration: none;">
                          <img
                            src="/images/lifestyle/luxvaldevie.jpg"
                            class="w-100 mb-3 lifestyle-img"
                            style="border-bottom-right-radius: 30px;"
                            alt="luxvdvaward"
                          />
                        </a>

                        <a href="/article/luxvdvaward" class="d-block" style="text-decoration: none;">
                         <h3 class="h4 text-start text-uppercase"><strong>
                         Global wellness listing the latest honour for Val de Vie
                          </strong></h3>
                        </a>

                        <p class="blog-text">
                       Val de Vie Estate, already renowned as the most secure estate in South Africa and the pinnacle of luxury living in the Cape Winelands, has added another international accolade to its growing list of achievements, after being named among the top 15 wellness estates in the world.
                        </p>
                      </div>

                    </div>
                  </div>


                  <div class="col-6 pb-5 d-flex" v-if="selectedCategory === 'all' || selectedCategory === 'legacy-investments'">
                    <div class="d-flex flex-column w-100">
                      <div class="p-3 bg-light rounded h-100 d-flex flex-column">
                        <a href="/article/luxwaterfall" class="d-block" style="text-decoration: none;">
                          <img
                            src="/images/lifestyle/luxwaterfall.jpg"
                            class="w-100 mb-3 lifestyle-img"
                            style="border-bottom-right-radius: 30px;"
                            alt="luxwaterfall"
                          />
                        </a>

                        <a href="/article/luxwaterfall" class="d-block" style="text-decoration: none;">
                         <h3 class="h4 text-start text-uppercase"><strong>
                         Waterfall City: The gold standard of smart living
                          </strong></h3>
                        </a>

                        <p class="blog-text">
                        The term “smart city” has become something of a buzzword in South Africa’s property sector, with several ambitious developments around Johannesburg laying claim to the title. Yet none so far have delivered on the promise as comprehensively  Waterfall City. 
                        </p>
                      </div>

                    </div>
                  </div>


                  <div class="col-6 pb-5 d-flex" v-if="selectedCategory === 'all' || selectedCategory === 'legacy-investments'">
                    <div class="d-flex flex-column w-100">
                      <div class="p-3 bg-light rounded h-100 d-flex flex-column">
                        <a href="/article/digital-wealth" class="d-block" style="text-decoration: none;">
                          <img
                            src="/images/lifestyle/digital-wealth.jpg"
                            class="w-100 mb-3 lifestyle-img"
                            style="border-bottom-right-radius: 30px;"
                            alt="digital wealth"
                          />
                        </a>

                        <a href="/article/digital-wealth" class="d-block" style="text-decoration: none;">
                         <h3 class="h4 text-start text-uppercase"><strong>
                         Moving between digital wealth and luxury property
                          </strong></h3>
                        </a>

                        <p class="blog-text">
                       Luxury property has always been one of the preferred ways for affluent individuals to preserve and grow wealth. Today, however, a growing number of high net-worth investors are also holding substantial portions of their wealth in digital assets such as Bitcoin, Ethereum, Solana and stablecoins.
                        </p>
                      </div>

                    </div>
                  </div>

                <div class="col-6 pb-5 d-flex" v-if="selectedCategory === 'all' || selectedCategory === 'wintering-well'">
                    <div class="d-flex flex-column w-100">
                      <div class="p-3 bg-light rounded h-100 d-flex flex-column">
                        <a href="/article/wintering-well" class="d-block" style="text-decoration: none;">
                          <img
                            src="/images/lifestyle/wintering-well.jpg"
                            class="w-100 mb-3 lifestyle-img"
                            style="border-bottom-right-radius: 30px;"
                            alt="wintering well"
                          />
                        </a>

                        <a href="/article/wintering-well" class="d-block" style="text-decoration: none;">
                         <h3 class="h4 text-start text-uppercase"><strong>Sanctuary season: The art of wintering well</strong></h3>
                        </a>

                        <p class="blog-text">
                        With South Africa now firmly in the grip of winter, luxury homeowners are embracing a more intentional way of living that prioritises restoration, comfort and holistic wellbeing. 
                        </p>
                      </div>

                    </div>
                  </div>


                <div class="col-6 pb-5 d-flex" v-if="selectedCategory === 'all' || selectedCategory === 'going-global'">
                    <div class="d-flex flex-column w-100">
                      <div class="p-3 bg-light rounded h-100 d-flex flex-column">
                        <a href="/article/going-global" class="d-block" style="text-decoration: none;">
                          <img
                            src="/images/lifestyle/going-global.jpg"
                            class="w-100 mb-3 lifestyle-img"
                            style="border-bottom-right-radius: 30px;"
                            alt="going global"
                          />
                        </a>

                        <a href="/article/going-global" class="d-block" style="text-decoration: none;">
                         <h3 class="h4 text-start text-uppercase"><strong>Luxury without borders: Why affluent buyers are going global</strong></h3>
                        </a>

                        <p class="blog-text">
                        There are luxury estates, and then there are properties so rare in both concept and execution that they stand almost alone in the market. In Gauteng, Waterfall Equestrian Estate occupies precisely that space.
                        </p>
                      </div>

                    </div>
                  </div>

                <div class="col-6 pb-5 d-flex" v-if="selectedCategory === 'all' || selectedCategory === 'the-art-of-living'">
                    <div class="d-flex flex-column w-100">
                      <div class="p-3 bg-light rounded h-100 d-flex flex-column">
                        <a href="/article/waterfall-equestrian" class="d-block" style="text-decoration: none;">
                          <img
                            src="/images/lifestyle/waterfall-equestrian.jpg"
                            class="w-100 mb-3 lifestyle-img"
                            style="border-bottom-right-radius: 30px;"
                            alt="waterfall equestrian"
                          />
                        </a>

                        <a href="/article/waterfall-equestrian" class="d-block" style="text-decoration: none;">
                         <h3 class="h4 text-start text-uppercase"><strong>Waterfall Equestrian Estate: Country living in the embrace of the city</strong></h3>
                        </a>

                        <p class="blog-text">
                        There are luxury estates, and then there are properties so rare in both concept and execution that they stand almost alone in the market. In Gauteng, Waterfall Equestrian Estate occupies precisely that space.
                        </p>
                      </div>

                    </div>
                  </div>

                 <div class="col-6 pb-5 d-flex" v-if="selectedCategory === 'all' || selectedCategory === 'the-art-of-living'">
                    <div class="d-flex flex-column w-100">
                      <div class="p-3 bg-light rounded h-100 d-flex flex-column">
                        <a href="/article/zimbali" class="d-block" style="text-decoration: none;">
                          <img
                            src="/images/lifestyle/zimbali.jpg"
                            class="w-100 mb-3 lifestyle-img"
                            style="border-bottom-right-radius: 30px;"
                            alt="zimbali home"
                          />
                        </a>

                        <a href="/article/zimbali" class="d-block" style="text-decoration: none;">
                         <h3 class="h4 text-start text-uppercase"><strong>Zimbali: Where luxury slows to the rhythm of the ocean</strong></h3>
                        </a>

                        <p class="blog-text">
                        There are luxury estates, and then there are places so completely immersed in beauty, tranquility and effortless privilege that life itself seems to soften at the edges.
                        </p>
                      </div>

                    </div>
                  </div>

                        <div class="col-6 pb-5 d-flex" v-if="selectedCategory === 'all' || selectedCategory === 'the-art-of-living'">
                    <div class="d-flex flex-column w-100">
                      <div class="p-3 bg-light rounded h-100 d-flex flex-column">
                        <a href="/article/reside-awards" class="d-block" style="text-decoration: none;">
                          <img
                            src="/images/lifestyle/reside-awards.png"
                            class="w-100 mb-3 lifestyle-img"
                            style="border-bottom-right-radius: 30px;"
                            alt="reside awards"
                          />
                        </a>

                        <a href="/article/reside-awards" class="d-block" style="text-decoration: none;">
                         <h3 class="h4 text-start text-uppercase"><strong>Top honours for Chas Everitt luxury nominees at Reside Awards</strong></h3>
                        </a>

                        <p class="blog-text">
                         South Africa’s finest lifestyle estates and luxury residential developments took centre stage in the inaugural Luxury Residential category of the prestigious Reside Awards ceremony held recently in Johannesburg, with six developments that were nominated by Chas Everitt International earning top honours.
                        </p>
                      </div>

                     <!-- <a
                        class="social-links switch-bg-dblue mb-0 cta-link"
                        href="/article/reside-awards"
                        id="lifestyle-cta"
                      > 
                        READ MORE
                      </a> -->
                    </div>
                  </div>

                  <div class="col-6 pb-5 d-flex" v-if="selectedCategory === 'all' || selectedCategory === 'the-art-of-living'">
                    <div class="d-flex flex-column w-100">
                      <div class="p-3 bg-light rounded h-100 d-flex flex-column">
                        <a href="/article/longevity" class="d-block" style="text-decoration: none;">
                          <img
                            src="/images/lifestyle/longevity.jpg"
                            class="w-100 mb-3 lifestyle-img"
                            style="border-bottom-right-radius: 30px;"
                            alt="Cultivating longevity"
                          />
                        </a>

                        <a href="/article/longevity" class="d-block" style="text-decoration: none;">
                          <h3 class="h4 text-start text-uppercase">
                            <strong>Cultivating longevity: SA Blue Zone vision starts to take root</strong>
                          </h3>
                        </a>

                        <p class="blog-text">
                          In the heart of the Western Cape’s most celebrated landscape, a quiet but powerful
                          lifestyle movement is taking shape, inspired by the world’s renowned Blue Zones,
                          those rare regions where people live markedly longer, healthier and more connected lives.
                        </p>
                      </div>

                     <!-- <a
                        class="social-links switch-bg-dblue mb-0 cta-link"
                        href="/article/longevity"
                        id="lifestyle-cta"
                      > 
                        READ MORE
                      </a> -->
                    </div>
                  </div>

                  <div class="col-6 pb-5 d-flex" v-if="selectedCategory === 'all' || selectedCategory === 'signature-estates'">
                    <div class="d-flex flex-column w-100">
                      <div class="p-3 bg-light rounded h-100 d-flex flex-column">
                        <a href="/article/coming-home" class="d-block">
                          <img
                            src="/images/lifestyle/coming-home.jpg"
                            class="w-100 mb-3 lifestyle-img"
                            style="border-bottom-right-radius: 30px;"
                            alt="Coming home"
                          />
                        </a>

                        <a href="/article/coming-home" class="d-block" style="text-decoration: none;">
                          <h3 class="h4 text-start text-uppercase">
                            <strong>Why South Africa's “scatterlings” are coming home - and buying big DATE</strong>
                          </h3>
                        </a>

                        <p class="blog-text">
                          South African expats continue to return to the country in droves, and not just to be with family or enjoy our exceptional lifestyle, but often specifically to buy some of the best-value luxury real estate in the world.
                        </p>
                      </div>

                     
                    </div>
                  </div>

                  <div class="col-6 pb-5 d-flex" v-if="selectedCategory === 'all' || selectedCategory === 'signature-estates'">
                    <div class="d-flex flex-column w-100">
                      <div class="p-3 bg-light rounded h-100 d-flex flex-column">
                        <a href="/article/lifestyle-cities" style="text-decoration: none;" class="d-block">
                          <img src="/images/lifestyle/lifestyle-cities.jpg" style="border-bottom-right-radius: 30px;" class="w-100 mb-3 lifestyle-img" />
                        </a>

                        <a href="/article/lifestyle-cities" style="text-decoration: none;" class="d-block">
                          <h3 class="h4 text-start text-uppercase"><strong>Wellness, Wealth & Waterfronts: Top 10 Lifestyle Cities Dominating 2025’s Luxury Real Estate Map</strong></h3>
                        </a>
                        <p class="blog-text">From Florence to Cape Town and Dubai, JamesEdition Data Insights spotlight the cities redefining luxury living for the world’s wealthiest buyers.</p>
                      </div>
                      
                    </div>
                  </div>

                  <div class="col-6 pb-5 d-flex" v-if="selectedCategory === 'all' || selectedCategory === 'signature-estates'">
                    <div class="d-flex flex-column w-100">
                      <div class="p-3 bg-light rounded h-100 d-flex flex-column">
                        <a href="/article/millionaires-in-africa" style="text-decoration: none;" class="d-block">
                          <img src="/images/lifestyle/millionaires-in-africa.jpg" style="border-bottom-right-radius: 30px;" class="w-100 mb-3 lifestyle-img" />
                        </a>

                        <a href="/article/millionaires-in-africa" style="text-decoration: none;" class="d-block">
                          <h3 class="h4 text-start text-uppercase"><strong>Here's what moves millionaires in Africa</strong></h3>
                        </a>
                        <p class="blog-text">Global wealth is on the move as high-net-worth individuals relocate from longstanding wealth strongholds to other countries in increasing numbers. And via the Leading Real Estate Companies of the World®️ network, we are seeing a clear impact on luxury property markets in the emerging wealth hubs that are attracting millionaires.</p>
                      </div>
                      
                    </div>
                  </div>

                  <div class="col-6 pb-5 d-flex" v-if="selectedCategory === 'all' || selectedCategory === 'signature-estates'">
                    <div class="d-flex flex-column w-100">
                      <div class="p-3 bg-light rounded h-100 d-flex flex-column">
                        <a href="/article/highlife">
                          <img src="/images/lifestyle/highlife.jpg" style="border-bottom-right-radius: 30px;" class="w-100 mb-3 lifestyle-img" />
                        </a>

                        <a href="/article/highlife" style="text-decoration:none; color:inherit;">
                          <h3 class="h4 text-start text-uppercase"><strong>Living the high life in Africa’s richest city </strong></h3>
                        </a>
                        <p class="blog-text">The new development tap has been turned back on in Johannesburg, and buyers and investors are snapping up
                          luxury apartments and penthouses worth billions of rands in the city’s most desirable suburbs.</p>
                      </div>

                    </div>
                  </div>

                  <div class="col-6 pb-5 d-flex" v-if="selectedCategory === 'all' || selectedCategory === 'inspired-interiors'">
                    <div class="d-flex flex-column w-100">
                      <div class="p-3 bg-light rounded h-100 d-flex flex-column">
                        <a href="/article/simplicity">
                          <img src="/images/lifestyle/simplicity.jpg" style="border-bottom-right-radius: 30px;" class="w-100 mb-3 lifestyle-img" />
                        </a>

                        <a href="/article/simplicity" style="text-decoration:none; color:inherit;">
                          <h3 class="h4 text-start text-uppercase"><strong>The luxury of simplicity: How to bring Cloud Dancer into your
                              home </strong></h3>
                        </a>
                        <p class="blog-text">As South Africans lean into longer days, open windows and effortless summer living, luxury homes are
                          embracing a new kind of elegance; one defined not by excess, but by calm. And Pantone’s 2026 Colour of the
                          Year, Cloud Dancer, captures this perfectly.</p>
                      </div>

                    </div>
                  </div>

                  <div class="col-6 pb-5 d-flex" v-if="selectedCategory === 'all' || selectedCategory === 'legacy-investments'">
                    <div class="d-flex flex-column w-100">
                      <div class="p-3 bg-light rounded h-100 d-flex flex-column">
                        <a href="/article/wildside">
                          <img src="/images/lifestyle/wildside.jpg" style="border-bottom-right-radius: 30px;" class="w-100 mb-3 lifestyle-img" />
                        </a>

                        <a href="/article/wildside" style="text-decoration:none; color:inherit;">
                          <h3 class="h4 text-start text-uppercase"><strong>Where nature rules: Investing on the wild side</strong></h3>
                        </a>
                        <p class="blog-text">Owning a home or a business on the edge of the internationally-renowned Kruger National Park is no longer just
                          a romantic dream of “wild Africa”. It is rapidly becoming a strategic lifestyle and investment choice for
                          discerning buyers from around the world.</p>
                      </div>
                      
                    </div>
                  </div>

                  <div class="col-6 pb-5 d-flex" v-if="selectedCategory === 'all' || selectedCategory === 'signature-estates'">
                    <div class="d-flex flex-column w-100">
                      <div class="p-3 bg-light rounded h-100 d-flex flex-column">
                        <a href="/article/moorings">
                          <img src="/images/lifestyle/moorings.jpg" style="border-bottom-right-radius: 30px;" class="w-100 mb-3 lifestyle-img" />
                        </a>

                        <a href="/article/moorings" style="text-decoration:none; color:inherit;">
                          <h3 class="h4 text-start text-uppercase"><strong>Luxury moorings: The allure of waterfront living in South
                              Africa</strong></h3>
                        </a>
                        <p class="blog-text">There is something eternally captivating about living beside water. Whether it’s the ocean’s rhythmic ebb and
                          flow, the still serenity of an inland dam, or the quiet lapping of a lagoon against your private jetty,
                          waterfront living has long been synonymous with luxury, tranquillity and the pleasures of boating.</p>
                      </div>
                  
                    </div>
                  </div>

                  <div class="col-6 pb-5 d-flex" v-if="selectedCategory === 'all' || selectedCategory === 'inspired-interiors'">
                    <div class="d-flex flex-column w-100">
                      <div class="p-3 bg-light rounded h-100 d-flex flex-column">
                        <a href="/article/warm-glow">
                          <img src="/images/lifestyle/fireplace.jpg" style="border-bottom-right-radius: 30px;" class="w-100 mb-3 lifestyle-img" />
                        </a>

                        <a href="/article/warm-glow" style="text-decoration:none; color:inherit;">
                          <h3 class="h4 text-start text-uppercase"><strong>The warm glow of luxury around fireplaces that elevate your home
                              all year round</strong></h3>
                        </a>
                        <p class="blog-text">For the luxury homeowner, a fireplace is usually far more than a heat source; it’s a thing of beauty and a
                          statement of comfort, style and sophistication. But in winter there is something especially indulgent about
                          gathering around a fire and whether you're sipping a glass of red in your lounge or entertaining guests under
                          the stars, you need the right fireplace to transform the space into an intimate sanctuary.</p>
                      </div>
                      
                    </div>
                  </div>

                  <div class="col-6 pb-5 d-flex" v-if="selectedCategory === 'all' || selectedCategory === 'the-art-of-living'">
                    <div class="d-flex flex-column w-100">
                      <div class="p-3 bg-light rounded h-100 d-flex flex-column">
                        <a href="/article/ultimate-retirement">
                          <img src="/images/lifestyle/retiring.jpg" style="border-bottom-right-radius: 30px;" class="w-100 mb-3 lifestyle-img" />
                        </a>

                        <a href="/article/ultimate-retirement" style="text-decoration:none; color:inherit;">
                          <h3 class="h4 text-start text-uppercase"><strong>The golden move: When retiring to the coast or country is the
                              ultimate luxury</strong></h3>
                        </a>
                        <p class="blog-text">As retirement approaches, many envision a life less hurried; mornings steeped in serenity, days framed by
                          nature and evenings spent in meaningful leisure. And for those seeking renewal as well as rest, relocating to
                          the coast or the countryside offers a luxurious redefinition of what retirement can be.</p>
                      </div>
                      
                    </div>
                  </div>

                  <div class="col-6 pb-5 d-flex" v-if="selectedCategory === 'all' || selectedCategory === 'signature-estates'">
                    <div class="d-flex flex-column w-100">
                      <div class="p-3 bg-light rounded h-100 d-flex flex-column">
                        <a href="/article/gauteng-gorgeous-estates">
                          <img src="/images/lifestyle/gorgeous-estate.jpg" style="border-bottom-right-radius: 30px;" class="w-100 mb-3 lifestyle-img" />
                        </a>

                        <a href="/article/gauteng-gorgeous-estates" style="text-decoration:none; color:inherit;">
                          <h3 class="h4 text-start text-uppercase"><strong>Luxury, lifestyle and value in Gauteng’s gorgeous estates</strong></h3>
                        </a>
                        <p class="blog-text">Affluent homebuyers the world over are increasingly drawn to lifestyle estates for several compelling reasons,
                          often tied to their desires for privacy, well-being and long-term value.</p>
                      </div>
                      
                    </div>
                  </div>

                  <div class="col-6 pb-5 d-flex" v-if="selectedCategory === 'all' || selectedCategory === 'the-art-of-living'">
                    <div class="d-flex flex-column w-100">
                      <div class="p-3 bg-light rounded h-100 d-flex flex-column">
                        <a href="/article/search-for-connection">
                          <img src="/images/lifestyle/ubuntu.jpg" style="border-bottom-right-radius: 30px;" class="w-100 mb-3 lifestyle-img" />
                        </a>

                        <a href="/article/search-for-connection" style="text-decoration:none; color:inherit;">
                          <h3 class="h4 text-start text-uppercase"><strong>The Search for Connection: How Ubuntu Informs Luxury Living in
                              SA</strong></h3>
                        </a>
                        <p class="blog-text">In the heart of South Africa’s architectural evolution, a deep-seated philosophy is showing up in an
                          increasing number of luxury homes and lifestyle estates.</p>
                      </div>
                      
                    </div>
                  </div>

                  <div class="col-6 pb-5 d-flex" v-if="selectedCategory === 'all' || selectedCategory === 'inspired-interiors'">
                    <div class="d-flex flex-column w-100">
                      <div class="p-3 bg-light rounded h-100 d-flex flex-column">
                        <a href="/article/elevating-luxury-living">
                          <img src="/images/lifestyle/elevating-luxury-living.jpg" style="border-bottom-right-radius: 30px;" class="w-100 mb-3 lifestyle-img" />
                        </a>

                        <a href="/article/elevating-luxury-living" style="text-decoration:none; color:inherit;">
                          <h3 class="h4 text-start text-uppercase"><strong>Elevating Luxury Living: The Art of Creating After-Dark
                              Retreats</strong></h3>
                        </a>
                        <p class="blog-text">As remote work continues to redefine modern lifestyles, homeowners are investing more than ever in
                          transforming their residences into versatile sanctuaries. With more time spent at home, living spaces are
                          evolving into multi-functional areas that cater to work, leisure and entertainment.</p>
                      </div>
                      
                    </div>
                  </div>

                  <div class="col-6 pb-5 d-flex" v-if="selectedCategory === 'all' || selectedCategory === 'fine-pursuits'">
                    <div class="d-flex flex-column w-100">
                      <div class="p-3 bg-light rounded h-100 d-flex flex-column">
                        <a href="/article/wine-as-a-luxury-experience">
                          <img src="/images/wine-as-a-luxury-experience.jpg" style="border-bottom-right-radius: 30px;" class="w-100 mb-3 lifestyle-img" />
                        </a>

                        <a href="/article/wine-as-a-luxury-experience" style="text-decoration:none; color:inherit;">
                          <h3 class="h4 text-start text-uppercase"><strong>Wine as a Luxury Experience</strong></h3>
                        </a>
                        <p class="blog-text">More than a leisurely sip, a good wine represents an enthralling journey from the heat of lush vineyards
                          through the cool cellars on historic estates and the thrill of private wine tastings to the satisfaction of
                          being able to savour a superior creation at home with dear friends or family.</p>
                      </div>

                    </div>
                  </div>

                  <div class="col-6 pb-5 d-flex" v-if="selectedCategory === 'all' || selectedCategory === 'legacy-investments'">
                    <div class="d-flex flex-column w-100">
                      <div class="p-3 bg-light rounded h-100 d-flex flex-column">
                        <a href="/article/new-year-new-luxury">
                          <img
                            src="https://fusionstoragelive.blob.core.windows.net/images/Listing/Office,801931/Photos,54877/pic_54877510.jpg"
                            style="border-bottom-right-radius: 30px;"
                            class="w-100 mb-3 lifestyle-img"
                          />
                        </a>

                        <a href="/article/new-year-new-luxury" style="text-decoration:none; color:inherit;">
                          <h3 class="h4 text-start text-uppercase"><strong>New year, new luxury</strong></h3>
                        </a>
                        <p class="blog-text">South Africa currently has one of the best performing luxury residential markets in the world. The country’s
                          beautiful and diverse landscapes offer something for everyone. Whether you love the mountains, winelands,
                          beach or bush, SA has exquisite luxury property options for you to choose from. And, with the country’s
                          tourism indutry showing little chance of slowing down, it offers a prime investment opportunity for luxury
                          buyers.</p>
                      </div>


                    </div>
                  </div>

                  <div class="col-6 pb-5 d-flex" v-if="selectedCategory === 'all' || selectedCategory === 'legacy-investments'">
                    <div class="d-flex flex-column w-100">
                      <div class="p-3 bg-light rounded h-100 d-flex flex-column">
                        <a href="/article/buy-a-luxury-holiday-home-in-south-africa">
                          <img src="/images/lifestyle/buy-a-luxury-holiday-home-in-south-africa.jpg" style="border-bottom-right-radius: 30px;" class="w-100 mb-3 lifestyle-img" />
                        </a>

                        <a href="/article/buy-a-luxury-holiday-home-in-south-africa" style="text-decoration:none; color:inherit;">
                          <h3 class="h4 text-start text-uppercase"><strong>From Vineyard Retreats to Coastal Estates: Reasons to Buy a Luxury
                              Holiday Home in South Africa</strong></h3>
                        </a>
                        <p class="blog-text">South Africa currently has one of the best performing luxury residential markets in the world. The country’s
                          beautiful and diverse landscapes offer something for everyone. Whether you love the mountains, winelands,
                          beach or bush, SA has exquisite luxury property options for you to choose from. And, with the country’s
                          tourism indutry showing little chance of slowing down, it offers a prime investment opportunity for luxury
                          buyers.</p>
                      </div>
                     
                    </div>
                  </div>

                  <div class="col-6 pb-5 d-flex" v-if="selectedCategory === 'all' || selectedCategory === 'exclusive-destinations'">
                    <div class="d-flex flex-column w-100">
                      <div class="p-3 bg-light rounded h-100 d-flex flex-column">
                        <a href="/article/luxurious-holiday-destinations">
                          <img src="/images/lifestyle/luxurious-holiday-destinations.jpg" style="border-bottom-right-radius: 30px;" class="w-100 mb-3 lifestyle-img" />
                        </a>

                        <a href="/article/luxurious-holiday-destinations" style="text-decoration:none; color:inherit;">
                          <h3 class="h4 text-start text-uppercase"><strong>The Most Luxurious Holiday Destinations to Visit in South Africa
                              This Season</strong></h3>
                        </a>
                        <p class="blog-text">When looking for an opulent, private and indulgent festive season getaway, look no further than South Africa.
                          Its diverse landscapes include, among others, wild African bush with free-roaming animals, exquisite coastlines
                          with soft sand and azure seas, and world-class vineyards that stretch as far as the eye can see.</p>
                      </div>
                      
                    </div>
                  </div>

                  <div class="col-6 pb-5 d-flex" v-if="selectedCategory === 'all' || selectedCategory === 'legacy-investments'">
                    <div class="d-flex flex-column w-100">
                      <div class="p-3 bg-light rounded h-100 d-flex flex-column">
                        <a href="/article/ultimate-guide-to-buying-a-luxury-holiday-home">
                          <img
                            src="https://fusionstoragelive.blob.core.windows.net/images/Listing/Office,801860/Photos,58895/pic_58895382.jpg"
                            style="border-bottom-right-radius: 30px;"
                            class="w-100 mb-3 lifestyle-img"
                          />
                        </a>

                        <a href="/article/ultimate-guide-to-buying-a-luxury-holiday-home" style="text-decoration:none; color:inherit;">
                          <h3 class="h4 text-start text-uppercase"><strong>The Ultimate Guide to Buying a Luxury Holiday Home</strong></h3>
                        </a>
                        <p class="blog-text">Owning a luxury holiday home in South Africa does more than give you access to more than the country’s
                          beautiful landscapes, diverse cultures and vibrant lifestyle – it provides you with a solid investment that
                          you can enjoy yourself or rent out to other holidaymakers from across the globe.</p>
                      </div>
                     
                    </div>
                  </div>

                  <div class="col-6 pb-5 d-flex" v-if="selectedCategory === 'all' || selectedCategory === 'inspired-interiors'">
                    <div class="d-flex flex-column w-100">
                      <div class="p-3 bg-light rounded h-100 d-flex flex-column">
                        <a href="/article/embrace-luxury-interior-design-trends">
                          <img src="/images/lifestyle/embrace-luxury-interior-design-trends.jpg" style="border-bottom-right-radius: 30px;" class="w-100 mb-3 lifestyle-img" />
                        </a>

                        <a href="/article/embrace-luxury-interior-design-trends" style="text-decoration:none; color:inherit;">
                          <h3 class="h4 text-start text-uppercase"><strong>Embrace Luxury Interior Design Trends</strong></h3>
                        </a>
                        <p class="blog-text">Luxury properties need to inspire from both an exterior and interior perspective. Investors should consider
                          the latest interior design trends to ensure that their property increases in value over time.</p>
                      </div>
                      
                    </div>
                  </div>

                  <div class="col-6 pb-5 d-flex" v-if="selectedCategory === 'all' || selectedCategory === 'the-art-of-living'">
                    <div class="d-flex flex-column w-100">
                      <div class="p-3 bg-light rounded h-100 d-flex flex-column">
                        <a href="/article/from-vineyards-to-villas">
                          <img src="/images/lifestyle/vineyards-to-villas.jpg" style="border-bottom-right-radius: 30px;" class="w-100 mb-3 lifestyle-img" />
                        </a>

                        <a href="/article/from-vineyards-to-villas" style="text-decoration:none; color:inherit;">
                          <h3 class="h4 text-start text-uppercase"><strong>From Vineyards to Villas</strong></h3>
                        </a>
                        <p class="blog-text">Luxury living is about more than a luxury home – it’s about lifestyle. It’s about the freedom to do what you
                          like when you like. It’s about being surrounded by the nature you love and the amenities you need without
                          having to sacrifice precious time and energy to get to them.</p>
                      </div>
                     
                    </div>
                  </div>

                  <div class="col-6 pb-5 d-flex" v-if="selectedCategory === 'all' || selectedCategory === 'exclusive-destinations'">
                    <div class="d-flex flex-column w-100">
                      <div class="p-3 bg-light rounded h-100 d-flex flex-column">
                        <a href="/article/the-ultimate-wellness-retreats">
                          <img src="/images/lifestyle/the-ultimate-wellness-retreats.jpg" style="border-bottom-right-radius: 30px;" class="w-100 mb-3 lifestyle-img" />
                        </a>

                        <a href="/article/the-ultimate-wellness-retreats" style="text-decoration:none; color:inherit;">
                          <h3 class="h4 text-start text-uppercase"><strong>The Ultimate Wellness Retreats.</strong></h3>
                        </a>
                        <p class="blog-text">South Africa is the perfect destination for luxury wellness retreats. With everything from rolling vineyards
                          and exquisite seascapes to endless wilderness, there is something to rejuvenate every soul.</p>
                      </div>

                    
                    </div>
                  </div>

                  <div class="col-6 pb-5 d-flex" v-if="selectedCategory === 'all' || selectedCategory === 'fine-pursuits'">
                    <div class="d-flex flex-column w-100">
                      <div class="p-3 bg-light rounded h-100 d-flex flex-column">
                        <a href="/article/the-art-of-fine-dining">
                          <img src="/images/lifestyle/the-art-of-fine-dining.jpg" style="border-bottom-right-radius: 30px;" class="w-100 mb-3 lifestyle-img" />
                        </a>

                        <a href="/article/the-art-of-fine-dining" style="text-decoration:none; color:inherit;">
                          <h3 class="h4 text-start text-uppercase"><strong>The Art of Fine Dining: Exploring top-rated restaurants around
                              the world</strong></h3>
                        </a>
                        <p class="blog-text">Luxury living is all about experiencing the finer things in life. From buying an expensive property or paying
                          people to tend to your every need, to dining out at the best restaurants the world has to offer, everyone
                          enjoys the finer things that money can buy.</p>
                      </div>
                      
                    </div>
                  </div>

                  <div class="col-6 pb-5 d-flex" v-if="selectedCategory === 'all' || selectedCategory === 'the-art-of-living'">
                    <div class="d-flex flex-column w-100">
                      <div class="p-3 bg-light rounded h-100 d-flex flex-column">
                        <a href="/article/the-finer-things">
                          <img src="/images/lifestyle/amazing-cars.jpg" style="border-bottom-right-radius: 30px;" class="w-100 mb-3 lifestyle-img" />
                        </a>

                        <a href="/article/the-finer-things" style="text-decoration:none; color:inherit;">
                          <h3 class="h4 text-start text-uppercase"><strong>An appreciation for the finer things in life</strong></h3>
                        </a>
                        <p class="blog-text">Luxury living is often associated with an appreciation for the finer things in life, such as supercars, fine
                          wines, and rare art pieces as a means to express style and taste.</p>
                      </div>
                      
                    </div>
                  </div>

                  <div class="col-6 pb-5 d-flex" v-if="selectedCategory === 'all' || selectedCategory === 'signature-estates'">
                    <div class="d-flex flex-column w-100">
                      <div class="p-3 bg-white rounded h-100 d-flex flex-column">
                        <a href="/article/amazing-suburbs">
                          <img src="/images/lifestyle/amazing-suburbs.jpg" style="border-bottom-left-radius: 30px;" class="w-100 mb-3 lifestyle-img" />
                        </a>

                        <a href="/article/amazing-suburbs" style="text-decoration:none; color:inherit;">
                          <h3 class="h4 text-start text-uppercase"><strong>Exploring South Africa’s most expensive suburbs</strong></h3>
                        </a>
                        <p class="blog-text">In 2023, the annual Africa Wealth Report, the definitive guide to Africa’s wealth and luxury sector, revealed
                          that there are more than 3700 homes in SA valued at more than USD1m (approx. R18,5m at the time) and that
                          Clifton, Bantry Bay, Fresnaye, Bishopscourt, Camps Bay & Bakoven, and Llandudno were South Africa’s most
                          exclusive suburbs.</p>
                      </div>

                      
                    </div>
                  </div>

                  <div class="col-6 pb-5 d-flex" v-if="selectedCategory === 'all' || selectedCategory === 'fine-pursuits'">
                    <div class="d-flex flex-column w-100">
                      <div class="p-3 bg-light rounded h-100 d-flex flex-column">
                        <a href="/article/luxury-watches-and-luxury-properties">
                          <img src="/images/lifestyle/watches-and-properties.jpg" style="border-bottom-right-radius: 30px;" class="w-100 mb-3 lifestyle-img" />
                        </a>

                        <a href="/article/luxury-watches-and-luxury-properties" style="text-decoration:none; color:inherit;">
                          <h3 class="h4 text-start text-uppercase"><strong>What do luxury watches and luxury properties have in
                              common?</strong></h3>
                        </a>
                        <p class="blog-text">We recently sat down with Johan Dreyer, Founder and CEO of Topwatch, to discuss the intersection of luxury
                          watches and luxury properties. They are both considered staples in a luxury investment portfolio and share
                          quite a few commonalities.</p>
                      </div>
                      
                    </div>
                  </div>

                  <div class="col-6 pb-5 d-flex" v-if="selectedCategory === 'all' || selectedCategory === 'fine-pursuits'">
                    <div class="d-flex flex-column w-100">
                      <div class="p-3 bg-white rounded h-100 d-flex flex-column">
                        <a href="/article/the-gallery-steyn-city">
                          <img src="/images/lifestyle/steyn-city.jpg" style="border-bottom-right-radius: 30px;" class="w-100 mb-3 lifestyle-img" />
                        </a>

                        <a href="/article/the-gallery-steyn-city" style="text-decoration:none; color:inherit;">
                          <h3 class="h4 text-start text-uppercase"><strong>The Gallery at Steyn City: Contemporary art with a local
                              twist</strong></h3>
                        </a>
                        <p class="blog-text">When The Gallery at Steyn City opened its doors on 22 March 2023, the Johannesburg art scene was blessed with
                          a prestigious exhibit of exquisite artwork and a new home for art collectors, investors and enthusiasts.</p>
                      </div>

                   
                    </div>
                  </div>

                  <div class="col-6 pb-5 d-flex" v-if="selectedCategory === 'all' || selectedCategory === 'inspired-interiors'">
                    <div class="d-flex flex-column w-100">
                      <div class="p-3 bg-light rounded h-100 d-flex flex-column">
                        <a href="/article/10-must-have-features">
                          <img src="/images/lifestyle/10-must-have-features.jpg" style="border-bottom-right-radius: 30px;" class="w-100 mb-3 lifestyle-img" />
                        </a>

                        <a href="/article/10-must-have-features" style="text-decoration:none; color:inherit;">
                          <h3 class="h4 text-start text-uppercase"><strong>10 must-have features for luxury homes</strong></h3>
                        </a>
                        <p class="blog-text">Certain features are standards in every home, such as a bedroom and a kitchen. However, when you enter the
                          realm of luxury living, high-end and sophisticated features become the hallmark of what it means to truly live
                          the lifestyle.</p>
                      </div>

                    </div>
                  </div>

                  <div class="col-6 pb-5 d-flex" v-if="selectedCategory === 'all' || selectedCategory === 'signature-estates'">
                    <div class="d-flex flex-column w-100">
                      <div class="p-3 bg-white rounded h-100 d-flex flex-column">
                        <a href="/article/south-african-equestrian-estates">
                          <img src="/images/lifestyle/blog-polo.png" style="border-bottom-left-radius: 30px;" class="w-100 mb-3 lifestyle-img" />
                        </a>

                        <a href="/article/south-african-equestrian-estates" style="text-decoration:none; color:inherit;">
                          <h3 class="h4 text-start text-uppercase"><strong>Which South African equestrian estate should you invest
                              in?</strong></h3>
                        </a>
                        <p class="blog-text">South Africa is a country that offers many interesting property investment opportunities for local and
                          overseas buyers. One of those lucrative opportunities is our beautiful and vast selection of equestrian
                          estates.</p>
                      </div>
                      
                    </div>
                  </div>

                  <div class="col-6 pb-5 d-flex" v-if="selectedCategory === 'all' || selectedCategory === 'signature-estates'">
                    <div class="d-flex flex-column w-100">
                      <div class="p-3 bg-light rounded h-100 d-flex flex-column">
                        <a href="/article/spotlight-on-plettenberg-bay">
                          <img
                            src="https://fusionstoragelive.blob.core.windows.net/images/Listing/Office,801896/Photos,52211/pic_52211165.jpg"
                            alt="plettenberg bay lifestyle article"
                            style="border-top-right-radius: 30px;"
                            width=""
                            height=""
                            class="w-100 mb-3 lifestyle-img"
                          />
                        </a>

                        <a href="/article/spotlight-on-plettenberg-bay" style="text-decoration:none; color:inherit;">
                          <h3 class="h4 text-start text-uppercase"><strong>Spotlight on Plettenberg Bay</strong></h3>
                        </a>
                        <p class="blog-text">Did you know that Plettenberg Bay (or simply Plett, as most South Africans call it) is one of the five most
                          expensive places to buy luxury property in the whole of Africa? According to the latest research by Henley &
                          Partners and New World Wealth, Cape Town is the most expensive place for Africa's super-wealthy to acquire a
                          prime 200sqm to 400sqm apartment (at an average of around R100 000/sqm), followed by Plett and Hermanus, tied
                          at around R42 000/sqm for prime apartments, and then by Umhlanga and Marrakech in Morocco, tied at R38
                          000/sqm.</p>
                      </div>
                    
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>

    <div class="mt-5">&nbsp;</div>

    <Footer />
  </div>
</template>

<script>
import Menu from '@/components/home/Menu.vue'
import Footer from '@/components/home/Footer.vue'

export default {
  components: {
    Menu,
    Footer
  },
  data() {
    return {
      selectedCategory: 'all',
      data: {

      }
    }
  },
}
</script>

<style scoped>
.filter-btn {
  font-size: 10px;
  min-width: 170px;
  text-align: center;
  border-radius: 20px;
  text-transform: uppercase;
}

.filter-btn.active {
  background-color: #0d6efd;
  border-color: #0d6efd;
  color: #fff;
}

.lifestyle-img {
  height: 240px;
  object-fit: cover;
  object-position: center;
}

.blog-text {
  flex-grow: 1;
}

@media (max-width: 991.98px) {
  .sticky-top {
    position: static !important;
  }

  .lifestyle-img {
    height: 220px;
  }
}

@media (max-width: 767.98px) {
  .col-6 {
    width: 100%;
  }

  .filter-btn {
    min-width: 100%;
  }

  .lifestyle-img {
    height: 200px;
  }
}
</style>